import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.inline-edit-credit-card-item.views.InlineItemCostCell`

export default defineMessages({
  costChangeTooltip: {
    id: `${scope}.costChangeTooltip`,
    defaultMessage: 'Original cost: {originalCost} {currency}',
  },
  costChangeAriaLabel: {
    id: `${scope}.costChangeAriaLabel`,
    defaultMessage: 'Cost changed',
  },
  totalCostAriaLabel: {
    id: `${scope}.totalCostAriaLabel`,
    defaultMessage: 'Total cost for {description}',
  },
  currencyAriaLabel: {
    id: `${scope}.currencyAriaLabel`,
    defaultMessage: 'Currency for {description}',
  },
  statusIdleAriaLabel: {
    id: `${scope}.statusIdleAriaLabel`,
    defaultMessage: 'Editable',
  },
  statusPendingAriaLabel: {
    id: `${scope}.statusPendingAriaLabel`,
    defaultMessage: 'Saving',
  },
  statusResolvedAriaLabel: {
    id: `${scope}.statusResolvedAriaLabel`,
    defaultMessage: 'Saved',
  },
  statusRejectedAriaLabel: {
    id: `${scope}.statusRejectedAriaLabel`,
    defaultMessage: 'Save failed',
  },
})
